import moment from 'moment-ja'

export default {
  name: 'DateTextPicker',
  inject: ['$validator'],
  props: {
    type: {
      type: String,
      default: 'date'
    },
    value: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    requiredValidate: {
      default: false
    },
    dataVvName: {
      default: null
    },
    dataVvAs: {
      default: null
    },
    errorMessages: {
      default: null
    },
    textDisabled: {
      type: Boolean,
      default: false
    },
    mondayOnly: {
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      default: false
    }
  },
  data: () => ({
    menuDate: false,
    modelInput: ''
  }),
  created () {
    this.modelInput = this.value
    if (this.modelInput === null) {
      this.modelInput = ''
    }
  },
  watch: {
    modelDate (val) {
      if (val !== null) {
        this.modelInput = val
      }
    }
  },
  computed: {
    mask () {
      if (this.type === 'month') {
        return '####-##'
      } else {
        return '####-##-##'
      }
    },
    modelDate: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onBlurInput () {
      if (this.type === 'month' && this.modelInput.length === 6) {
        const formated = moment(this.modelInput, 'YYYYMM').format('YYYY-MM')
        if (this.validateRange(formated)) {
          this.modelDate = formated
          return
        }
      } else if (this.type === 'date' && this.modelInput.length === 8) {
        const formated = moment(this.modelInput, 'YYYYMMDD').format('YYYY-MM-DD')
        if (this.validateRange(formated)) {
          this.modelDate = formated
          return
        }
      }
      this.modelInput = ''
      this.modelDate = null
    },
    validateRange (date) {
      if (this.min) {
        return date >= this.min
      }
      if (this.max) {
        return date <= this.max
      }
      return true
    },
    allowedDates (val) {
      if (this.mondayOnly) {
        return moment(val).day() === 1
      } else {
        return true
      }
    }
  }
}
